// Errores de login / magic link / canje de token: api2 responde
// { response: 0, code, message, retry_after? } (contrato §10 del plan).
export const getAuthErrorInfo = err => {
  const data = (err && err.response && err.response.data) || {};
  return {
    code: data.code || (err && err.code) || null,
    status: err && err.response ? err.response.status : null,
    retryAfter: Number(data.retry_after || (err && err.retry_after)) || null
  };
};

// code -> id de traducción.
const MESSAGE_IDS = {
  invalid_input: "login.errors.invalid_input",
  invalid_credentials: "error.loginData",
  invalid_token: "login.errors.invalid_token",
  unauthorized: "login.errors.unauthorized",
  logged_out: "main.loggedOut",
  too_many_attempts: "login.errors.too_many_attempts",
  reservation_cancelled: "login.errors.reservation_cancelled",
  reservation_not_confirmed: "login.errors.reservation_not_confirmed",
  stay_finished: "login.errors.stay_finished",
  captcha_required: "login.errors.captcha_required",
  captcha_failed: "login.errors.captcha_failed",
  captcha_unavailable: "login.errors.captcha_unavailable",
  temporarily_unavailable: "login.errors.temporarily_unavailable"
};

export const CAPTCHA_ERROR_CODES = [
  "captcha_required",
  "captcha_failed",
  "captcha_unavailable"
];
export const HOTEL_CONTACT_CODES = [
  "reservation_cancelled",
  "reservation_not_confirmed",
  "stay_finished"
];

export const getAuthErrorMessageId = ({ code, status }) => {
  if (code && MESSAGE_IDS[code]) return MESSAGE_IDS[code];
  if (status === 429) return "error.429";
  return "error.loginData";
};

export const retryMinutes = retryAfter =>
  Math.max(1, Math.ceil((Number(retryAfter) || 60) / 60));
